import type { PricingPlan } from '../types/subscription';

export const PRICING_PLANS: PricingPlan[] = [
  {
    id: 'free',
    name: 'Grátis',
    description: 'Perfeito para começar',
    monthlyPrice: 0,
    yearlyPrice: 0,
    yearlyDiscount: 0,
    features: [
      { name: '5 ideias de conteúdo por mês', included: true },
      { name: '1 plano de conteúdo por mês', included: true },
      { name: 'Calendário básico', included: true },
      { name: 'Análises básicas', included: false },
      { name: 'Suporte por email', included: true },
      { name: 'Hashtags & CTAs personalizados', included: false }
    ],
    ctaText: 'Começar Grátis',
    paymentLinks: {
      monthly: '',
      yearly: ''
    }
  },
  {
    id: 'premium',
    name: 'Premium',
    description: 'Para criadores em crescimento',
    monthlyPrice: 49,
    yearlyPrice: 499,
    yearlyDiscount: 15,
    features: [
      { name: '30 ideias de conteúdo por mês', included: true },
      { name: '2 planos de conteúdo por mês', included: true },
      { name: 'Recomendações de IA', included: true },
      { name: 'Análises básicas', included: true },
      { name: 'Suporte por email rápido', included: true },
      { name: 'Hashtags & CTAs personalizados', included: true }
    ],
    popular: true,
    tag: 'Mais Popular',
    ctaText: 'Começar Agora',
    paymentLinks: {
      monthly: 'https://buy.stripe.com/dR62a787Ecng9YkeUX?success_url=https://kontty.com/success?plan=premium',
      yearly: 'https://buy.stripe.com/00g5mj1Jg1ICgmI3ce?success_url=https://kontty.com/success?plan=premium_yearly'
    }
  },
  {
    id: 'pro',
    name: 'Pro',
    description: 'Solução completa para profissionais',
    monthlyPrice: 99,
    yearlyPrice: 999,
    yearlyDiscount: 20,
    features: [
      { name: '100 ideias de conteúdo por mês', included: true },
      { name: '5 planos de conteúdo por mês', included: true },
      { name: 'Recomendações de IA em tempo real', included: true },
      { name: 'Análises avançadas com tracking de competidores', included: true },
      { name: 'Suporte por chat ao vivo e email', included: true },
      { name: 'Hashtags & CTAs personalizados', included: true }
    ],
    tag: 'Melhor Custo-Benefício',
    ctaText: 'Escolher Pro',
    paymentLinks: {
      monthly: 'https://buy.stripe.com/dR6bKHdrYbjc5I4cMN?success_url=https://kontty.com/success?plan=pro',
      yearly: 'https://buy.stripe.com/3csdSPafM5YSb2o8ww?success_url=https://kontty.com/success?plan=pro_yearly'
    }
  }
];